import { mergeStyles, Stack, Text } from '@fluentui/react';

import ContentBox from '../../ContentBox';
import List from './List';

export default () => {
  return (
    <Stack className={contentStyles} tokens={{ childrenGap: 10 }}>
      <Text variant="xxLarge">Son Faturalar</Text>
      <ContentBox>
        <List />
      </ContentBox>
    </Stack>
  );
};

const contentStyles = mergeStyles({
  marginTop: "16px",
  marginLeft: "50%",
  width: "50%",
  transform: "translateX(-50%)",
});
